module.exports = __webpack_public_path__ + "img/wix.f6b740c1.png";